<template>
  <div class="wrapper faq-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>FAQ</h1>
          <div class="faq-box">
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('1')"
              v-bind:class="[show_contents == 1 ? 'active' : '']"
            >
              CDPアカウントについて
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('1') >= 0">
              <ul class="list">
                <li>
                  <h2><span>Q</span>登録・操作方法全般について</h2>
                  <p>
                    <span>A</span
                    ><a
                      href="https://develop-dev.work/pdf/cdp-way.pdf"
                      target="_blank"
                      >こちら</a
                    >より登録・操作方法をご参照ください。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('2')"
              v-bind:class="[show_contents == 2 ? 'active' : '']"
            >
              新規登録・紹介について
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('2') >= 0">
              <ul class="list">
                <li>
                  <h2><span>Q</span>CDPの紹介方法を教えてください。</h2>
                  <p>
                    <span>A</span
                    >CDPアカウントの紹介コードページより紹介用のURLを取得して紹介したい方へ渡してください。<br />
                    紹介URLはバイナリーツリーの左側用と右側用の2種類あります。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('3')"
              v-bind:class="[show_contents == 3 ? 'active' : '']"
            >
              登録情報について
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('3') >= 0">
              <ul class="list">
                <li>
                  <h2><span>Q</span>ユーザー名を変更したい。</h2>
                  <p>
                    <span>A</span>登録完了後のユーザー名の変更はできません。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('4')"
              v-bind:class="[show_contents == 4 ? 'active' : '']"
            >
              入金・出金について
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('4') >= 0">
              <ul class="list">
                <li>
                  <h2>
                    <span>Q</span>どのように入金すればよろしいでしょうか？
                  </h2>
                  <p>
                    <span>A</span
                    >CDPアカウントのチャージページにて送金予定の仮想通貨を選択して、受け取り用のアドレスを取得してください。
                  </p>
                </li>
                <li>
                  <h2>
                    <span>Q</span
                    >出金申請をしてから、どれくらいで承認されますか？
                  </h2>
                  <p><span>A</span>早くて1－2日で承認されます。</p>
                </li>
                <li>
                  <h2><span>Q</span>最低出金額はありますでしょうか？</h2>
                  <p><span>A</span>可能最低出金額は200USDです。</p>
                </li>
                <li>
                  <h2><span>Q</span>出金はどの通貨で行われますか？</h2>
                  <p>
                    <span>A</span
                    >ボーナスなどUSDの出金はBTCで送金されますので、BTCの受け取り用アドレスを用意してください。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('5')"
              v-bind:class="[show_contents == 5 ? 'active' : '']"
            >
              パスワード＆メールアドレス
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('5') >= 0">
              <ul class="list">
                <li>
                  <h2><span>Q</span>メールアドレスは変更できますか？</h2>
                  <p>
                    <span>A</span
                    >CDPアカウントのアカウントページよりメールアドレスの変更が可能です。
                  </p>
                </li>
                <li>
                  <h2>
                    <span>Q</span
                    >ログインパスワードを忘れてしまい、ログインができなくなりました。
                  </h2>
                  <p>
                    <span>A</span
                    >ログイン画面より「パスワードをお忘れですか」をタップしていただき、パスワードの再設定を行ってください。
                  </p>
                </li>
                <li>
                  <h2><span>Q</span>ログインパスワードは変更できますか？</h2>
                  <p>
                    <span>A</span
                    >CDPアカウントのアカウントページよりパスワードの変更が可能です。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('6')"
              v-bind:class="[show_contents == 6 ? 'active' : '']"
            >
              二段階認証について
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('6') >= 0">
              <ul class="list">
                <li>
                  <h2><span>Q</span>二段階認証を設定したい。</h2>
                  <p>
                    <span>A</span
                    >CDPアカウントのアカウントページより二段階認証の設定を行うことができます。<br />
                    詳しくは<a
                      href="https://develop-dev.work/pdf/cdp-way.pdf"
                      target="_blank"
                      >操作マニュアル</a
                    >の25ぺージ目を確認してください。
                  </p>
                </li>
                <li>
                  <h2><span>Q</span>二段階認証を解除したい。</h2>
                  <p>
                    <span>A</span
                    >CDPアカウントのアカウントページより二段階認証の認証ボタンをタップしてください。<br />
                    6桁のGoogle認証コードを入力し、「Disable
                    two-factor」をタップしてください。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('7')"
              v-bind:class="[show_contents == 7 ? 'active' : '']"
            >
              プラン購入について
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('7') >= 0">
              <ul class="list">
                <li>
                  <h2>
                    <span>Q</span>ボーナスをプラン購入にあてることはできますか？
                  </h2>
                  <p>
                    <span>A</span
                    >はい、USD、PP、RPでプランを追加購入できます。カスタムプランを選択することにより任意の金額で追加購入が可能です。<br />
                    ただし最低購入額は200USDとなっています。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('8')"
              v-bind:class="[show_contents == 8 ? 'active' : '']"
            >
              ログインについて
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('8') >= 0">
              <ul class="list">
                <li>
                  <h2><span>Q</span>ログインができません。</h2>
                  <p>
                    <span>A</span
                    >ログイン時に正しいユーザー名とパスワードを入力していますでしょうか？<br />
                    パスワードが不明の場合はログイン画面の「パスワードをお忘れですか」より再設定を行ってください。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('9')"
              v-bind:class="[show_contents == 9 ? 'active' : '']"
            >
              直紹介・バイナリーボーナスについて
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('9') >= 0">
              <ul class="list">
                <li>
                  <h2>
                    <span>Q</span>紹介をした場合にいつボーナスが払われますか？
                  </h2>
                  <p>
                    <span>A</span
                    >直紹介ボーナスは当日、バイナリー系のボーナスは翌日にアカウントに反映されます。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('10')"
              v-bind:class="[show_contents == 10 ? 'active' : '']"
            >
              ステーキングについて
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('10') >= 0">
              <ul class="list">
                <li>
                  <h2>
                    <span>Q</span
                    >ステーキングを開始するにはどうしたら良いですか？
                  </h2>
                  <p>
                    <span>A</span
                    >CDPアカウントのプラン購入ページにてプランを選択してください。なお、カスタムプランの最低購入金額は200USDからとなっています。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('11')"
              v-bind:class="[show_contents == 11 ? 'active' : '']"
            >
              各種ポイントについて
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('11') >= 0">
              <ul class="list">
                <li>
                  <h2>
                    <span>Q</span
                    >USD、AP、RP、PPとはそれぞれどのようなポイントでしょうか？
                  </h2>
                  <p>
                    <span>A</span>
                    USD：プランの購入や出金が可能なポイントでBTC・ETH・USDTでの入金に対し、エクスチェンジされ付与されます。またボーナス関連もUSDとして付与されます。<br /><br />
                    AP：ステーキングしている数<br /><br />
                    RP：プランの増資やユーザーへの転送が可能なポイント<br /><br />
                    PP：バイナリーボーナスの上限を超えたポイント。また、元本が$50,000に達するまでは、バイナリーボーナスの20%は増資ポイントとして付与される。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
            <!--  -->
            <div
              class="question link-over"
              v-on:click="toggle('12')"
              v-bind:class="[show_contents == 12 ? 'active' : '']"
            >
              セミナーについて
              <span class="bar">
                <span class="line line1"></span>
                <span class="line line2"></span>
              </span>
            </div>
            <div class="answer" v-show="show_contents.indexOf('12') >= 0">
              <ul class="list">
                <li>
                  <h2><span>Q</span>セミナー日程はどちらで確認できますか？</h2>
                  <p>
                    <span>A</span
                    ><a href="https://lin.ee/b5kW8R8" target="_blank"
                      >CDP公式LINEアカウント</a
                    >で最新のセミナー日程をご確認いただけます。
                  </p>
                </li>
              </ul>
            </div>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer title="FaqList" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "FaqList",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "FaqList",
      show_contents: [],
    };
  },
  methods: {
    toggle: function (data) {
      if (this.show_contents.indexOf(data) >= 0) {
        this.show_contents = this.show_contents.filter((n) => n !== data);
      } else {
        this.show_contents.push(data);
      }
    },
  },
  computed: {},
  mounted: function () {},
};
</script>
